import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { DisabledReasonPopOver, Icon } from '@ztechapps/webui.util'

export type ConversationActionItemProps = {
  icon: string
  label: string
  onClick: () => void
  /** Set when the user may not do this — the item stays in the menu, disabled, with the reason in a tooltip. */
  disabledReason?: string
}

// A menu item of the conversation actions dropdown.
export const ConversationActionItem = ({ icon, label, onClick, disabledReason }: ConversationActionItemProps) => (
  <DisabledReasonPopOver reason={disabledReason}>
    <Dropdown.Item as="button" type="button" onClick={onClick} disabled={!!disabledReason}>
      <Icon name={icon} aria-hidden="true" /> {label}
    </Dropdown.Item>
  </DisabledReasonPopOver>
)
